
		<form class="model-form compact" [formGroup]="form" (ngSubmit)="submitted.emit(form.value)">
			<section class="form-block">
				<ng-container modelField></ng-container>
			</section>
		</form>
	